document.addEventListener('DOMContentLoaded', function () {
    //======================= Open popUP ===========================
    document.querySelector(".product-block-group--checkin-store .checkin-store-button").addEventListener('click', function () {
        document.querySelector(".m-modal-store-stock").classList.add("m-open-modal");
        document.querySelector(".m-modal-store-stock").style.opacity = "1";
        document.querySelector(".m-modal-location").classList.add("m-open-modal");
        document.querySelector(".m-modal-location").style.opacity = "1";
    });

    //======================= Closed popUP ===========================
    document.querySelector(".m-modal-store-stock .m-modal--close").addEventListener('click', function () {
        document.querySelector(".m-modal-store-stock").classList.remove("m-open-modal");
        document.querySelector(".m-modal-store-stock").style.opacity = "0";
        document.querySelector(".m-modal-location").classList.remove("m-open-modal");
        document.querySelector(".m-modal-location").style.opacity = "0";
    });


    //======================= Out side click -- Closed popUP ===========================
    document.querySelector('.m-modal-store-stock').addEventListener('click', function (e) {
        if (!e.target.closest('.m-modal-store-stock .m-modal--content')) {
            document.querySelector(".m-modal-store-stock").classList.remove("m-open-modal");
            document.querySelector(".m-modal-store-stock").style.opacity = "0";
        }
    });

    document.querySelector('.m-modal-location').addEventListener('click', function (e) {
        if (!e.target.closest('.m-modal-location .m-modal--content')) {
            document.querySelector(".m-modal-location").classList.remove("m-open-modal");
            document.querySelector(".m-modal-location").style.opacity = "0";
        }
    });

    // ========================================== Do your code above side ===================================
});
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(".userlocation-button, .btn-my-location").forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            document.querySelector(".m-modal-store-stock .size-with-store-details").style.display = 'none';
            if (event.currentTarget.classList.contains("btn-my-location")) {
                document.querySelector(".m-modal-location").classList.remove("m-open-modal");
                document.querySelector(".m-modal-location").style.opacity = "0";
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var lat = position.coords.latitude;
                        var lng = position.coords.longitude;
                        get_current_location(lat, lng);
                    },
                    function (error) {
                        console.error("Error getting location: " + error.message);
                    }
                );
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        });
    });
});

//new get_current_location code
async function get_current_location(latitude, longitude) {
    const apiKey = "AIzaSyArw9Vj4tiGNdRJoMXUJVtvEw0jZUcgBLs"; // Google API key
    const lat = latitude;
    const lng = longitude;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === "OK") {
            const results = data.results[0];
            const addressComponents = results.address_components;

            let country = "",
                province = "",
                suburb = "";
            addressComponents.forEach((component) => {
                if (component.types.includes("country")) {
                    country = component.short_name;
                } else if (component.types.includes("administrative_area_level_1")) {
                    province = component.long_name;
                } else if (
                    component.types.includes("sublocality_level_2") ||
                    component.types.includes("sublocality_level_1") ||
                    component.types.includes("sublocality")
                ) {
                    suburb = component.long_name;
                }
            });
            // country check
            if (
                country === "ZA" ||
                country === "NA" ||
                country === "LS" ||
                country === "SZ" ||
                country === "BW"
            ) {

                await fetch_closest_stores_with_stock(lat, lng);

            } else {
                const defaultLat = -24.599596; // Default latitude
                const defaultLng = 31.048521; // Default longitude
                await get_current_location(defaultLat, defaultLng);
                console.error("Location is not in South Africa.");
            }
        } else {
            console.error("Geocoding API error:", data.status);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
}

async function fetch_closest_stores_with_stock(lat, lng) {
    try {
        const liveSku = document.querySelector("#pro-variants option:checked").getAttribute("data-sku");

        document.querySelector(".m-modal-store-stock").classList.add("m-spinner-loading");
        const lnglatbody = {
            'longitude': lng,
            'latitude': lat,
            'sku': liveSku
        };

        const response = await fetch(get_all_store_data_long_lat, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${middleware_api_key}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(lnglatbody)
        }).then(res => res.json());

        const storesWithDistance = response.map(item => {
            const distance = calculateDistance(lat, lng, item.latitude, item.longitude);
            return { ...item, distance };
        }).sort((a, b) => a.distance - b.distance);

        const storesWithinRadius = storesWithDistance.filter(item => item.distance <= 50).slice(0, 20);

//         const storePromises = storesWithinRadius.map(item => selected_store_Data(item.branchCode, liveSku));
//         const storeResponses = await Promise.all(storePromises);
//
//         const itemsWithStock = storeResponses
//             .filter(storeResponse => storeResponse && storeResponse.qty > 0)
//             .map(storeResponse => response.find(resItem => resItem.branchCode.includes(storeResponse.branch)));
// console.log('te' , itemsWithStock);
        if (storesWithDistance.length === 0) {
            const data = { responseText: "No stores found with stock " };
            showing_error_result(data, document.querySelector("#store-stock"));
        } else {
            showing_result_store_stock(storesWithDistance);
        }
        document.querySelector(".m-modal-store-stock").classList.remove("m-spinner-loading");
    } catch (error) {
        console.error("Error fetching data", error);
    }
}

function calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
}
//end new get_current_location code
document.addEventListener('DOMContentLoaded', function () {
    document.querySelector("#pro-variants").addEventListener('change', function () {
        var selsku = document.querySelector("#pro-variants option:checked").getAttribute("data-sku");
        document.querySelector(".m-modal-store-stock .error-message").textContent = "";
        document.querySelector(".product-details .sku-label .inner-txt").textContent = selsku;
        document.querySelector(".m-modal-store-stock .size-with-store-details").style.display = 'none';

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async function (position) {
                    var lat = position.coords.latitude;
                    var lng = position.coords.longitude;
                    await fetch_closest_stores_with_stock(lat, lng);
                },
                function (error) {
                    console.error("Error getting location: " + error.message);
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    });



    document.querySelector("#store-stock-list").addEventListener('click', function (event) {
        if (event.target.classList.contains('store-stock-item')) {
            var selVal = event.target.getAttribute('data-branch-code');
            document.querySelector(".m-modal-store-stock .error-message").textContent = "";
            showSuggestions(selVal);
        }
    });
});

async function selected_store_Data(selected_store, selected_sku) {
    const live_sku = selected_sku || document.querySelector("#pro-variants option:checked").getAttribute("data-sku");
    if (live_sku) {
        try {
            const response = await fetch(`${selected_store_data_Url}/${live_sku}/location/${selected_store}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${middleware_api_key}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching data", error);
            alert("No inventory found on selected store");
            return null;
        }
    } else {
        alert("Please select the variant");
        return null;
    }
}


function showing_error_result(data, element) {
    element.innerHTML = `${data.responseText}`;
}

function showing_result_store_stock(data) {
    const listContainer = document.querySelector("#store-stock-list");

    if (!listContainer) {
        console.error("Element #store-stock-list not found in the DOM");
        return;
    }

    console.log("Data received:", data);

    listContainer.innerHTML = ''; // Clear previous list items


    if (!Array.isArray(data) || data.length === 0) {
        console.error("No data available to display");
        return;
    }

    data.forEach(storeArray => {
        if (Array.isArray(storeArray)) {
            storeArray.forEach(storeItem => {
                processStoreItem(storeItem, listContainer);
            });
        } else if (storeArray && typeof storeArray === 'object') {
            Object.values(storeArray).forEach(storeItem => {
                processStoreItem(storeItem, listContainer);
            });
        } else {
            console.error("storeArray is not an array or object:", storeArray);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {

    document.body.addEventListener("click", function (event) {
        if (event.target.classList.contains("hours-link")) {
            event.preventDefault();

            const hoursDisplay = event.target
                .closest(".content-holder")
                .querySelector(".hours-link-display");

            if (hoursDisplay) {
                hoursDisplay.style.display =
                    hoursDisplay.style.display === "none" ? "block" : "none";
            }
        }
    });
});

function processStoreItem(storeItem, listContainer) {
    console.log("Store ID:", storeItem.id);
    if (storeItem.id) {
        console.log('store', storeItem);
        const listItem = document.createElement('li');
        listItem.className = 'store-stock-item';
        const schedule = JSON.parse(storeItem.openingHours);
        let formattedPepHours = "";

        for (const [day, times] of Object.entries(schedule)) {
            const open = times.open ? times.open.slice(0, 5) : "Closed";
            const close = times.close ? times.close.slice(0, 5) : "Closed";
            const allDay = times.all_day ? "Open All Day" : `${open} - ${close}`;
            formattedPepHours += `<p><strong>${day.charAt(0).toUpperCase() + day.slice(1)}:</strong> ${allDay}</p>`;
        }
        listItem.innerHTML = `
<div class="store-detail">
    <div class="instock-display">
        IN STOCK
        <br>
        <span>(Availability is based on yesterday's stock)</span>
    </div>
    <div class="store-name-heading">
        <h3>${storeItem.storeName}</h3>
        <span>
          <span class="store-item-distance">${storeItem.distance}</span><span class="store-item-distance-km">km</span>
        </span>
    </div>
    <span>Store code: ${storeItem.branchCode}</span>
    <div class="content-holder">
        <div class="address">
            ${storeItem.address1}, ${storeItem.address2}, ${storeItem.province}
        </div>
        <div class="links-holder">
            <span class="holder-links">
              <a class="phone-link" href="tel:${storeItem.phone}">
                  ${storeItem.phone}
              </a>
            </span>
            <span class="holder-links">
              <a href="#" class="hours-link">Store open times</a>
            </span>
        </div>
        <div class="hours-link-display" style="display: none;">
            ${formattedPepHours}
        </div>
    </div>
    <hr>
</div>
        `;
        listContainer.appendChild(listItem);
    } else {
        console.error("Store ID is missing or invalid:", storeItem);
    }
}
// function processStoreItem(storeItem, listContainer) {
//     console.log("Store ID:", storeItem.id);
//     if (storeItem.id) {
//         console.log('store', storeItem);
//         const listItem = document.createElement('li');
//         listItem.className = 'store-stock-item';
//         listItem.innerHTML = `
//             <strong>Store Name:</strong> ${storeItem.storeName}<br>
//             <strong>Branch Code:</strong> ${storeItem.branchCode}<br>
//             <strong>Distance:</strong> ${storeItem.distance} km<br>
//             <strong>Address:</strong> ${storeItem.address1}, ${storeItem.address2}, ${storeItem.province}<br>
//             <strong>Phone:</strong> ${storeItem.phone}
//         `;
//         listContainer.appendChild(listItem);
//     } else {
//         console.error("Store ID is missing or invalid:", storeItem);
//     }
// }
function showing_final_result(data) {
    const selectBox = document.querySelector(".m-modal-store-stock .size-with-store-details");
    const allvari = document.querySelectorAll(".product-selectable-attributes button");
    const selectvari = document.querySelector(`.product-selectable-attributes button[data-sku-id='${data}']`);
    if (data) {
        allvari.forEach(button => button.classList.add("unavail"));
        selectvari.classList.remove("unavail");
        selectBox.style.display = 'block';
        document.querySelector(".m-modal-store-stock .error-message").textContent = "";
    }
}

let storeData = []; // Initialize an empty array
async function fetchStoreData() {
    try {
        const response = await fetch(get_all_store_data, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${middleware_api_key}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        storeData = await response.json();
    } catch (error) {
        console.error("Error fetching data", error);
    }
}
fetchStoreData();

async function showSuggestions(store_id) {
    const sku_id = document.querySelector("#pro-variants option:checked").getAttribute("data-sku");
    const input = store_id.toLowerCase();
    const suggestions = storeData.filter(store => {
        return (store.branchCode ? store.branchCode.toLowerCase() : "").includes(input);
    });
    displaySuggestions(suggestions);
    showing_final_result(sku_id);
}

async function displaySuggestions(suggestions) {
    const suggestionBox = document.querySelector(".m-modal-store-stock .store-details");
    suggestionBox.innerHTML = ""; // Clear previous suggestions
    suggestions.forEach(suggestion => {
        const schedule = JSON.parse(suggestion.openingHours);
        let formattedHours = "";

        for (const [day, times] of Object.entries(schedule)) {
            const open = times.open ? times.open : "Closed";
            const close = times.close ? times.close : "Closed";
            const allDay = times.all_day ? "Open All Day" : `${open} - ${close}`;
            formattedHours += `<p><strong>${day.charAt(0).toUpperCase() + day.slice(1)}:</strong> ${allDay}</p>`;
        }

        const new_html = `
            <h4>Store contact details</h4>
            <p>${suggestion.address1}, ${suggestion.address2}, ${suggestion.province}</p>
            <div class="row">
                <div class="col"><a class="tell-link" href="tel:${suggestion.phone}">
                    <span class="phone-icon">
                        <img src="https://cdn.shopify.com/s/files/1/0652/8634/0780/files/phone-call.png?v=1721887378" width="" height="">
                    </span> ${suggestion.phone}</a>
                </div>
                <div class="col">
                    <a href="#" class="show-store-link">Show store times</a>
                    <div class="store-hours">
                        <b>Store times</b>
                        ${formattedHours}
                    </div>
                </div>
            </div>
        `;
        suggestionBox.insertAdjacentHTML('beforeend', new_html);
    });
    Update_events();
}

function Update_events() {
    document.querySelectorAll(".store-details .show-store-link").forEach(link => {
        link.addEventListener('click', function () {
            this.style.display = 'none';
            this.nextElementSibling.style.display = 'block';
        });
    });
}